import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import styled from "styled-components";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import PublicIcon from "@material-ui/icons/Public";
import { getTotalPrice } from "../../../../../store/wlrBroadband/selectors";
import { useTheme } from "@material-ui/core/styles";

const CustomCell = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

const CustomArrowForwardIcon = styled(ArrowForwardIcon)`
  color: ${p => p.theme.palette.text.disabled};
  margin-left: 10px;
  margin-right: 10px;
`;

function MPFProductChangesRow({
  isChecked,
  toggleRow,
  productInstance,
  resignProduct,
  actions
}) {
  const theme = useTheme();

  const isResignProduct = resignProduct.components[0].is_resign;
  const resignProductName = resignProduct.name_for_resign || resignProduct.name;
  const resignProductPrice =
    resignProduct.price.first_bill_recurring_price_with_promotions;
  return (
    <TableRow selected={isChecked}>
      <TableCell>
        <Checkbox onChange={toggleRow} checked={isChecked} />
      </TableCell>
      <TableCell>{productInstance.pin}</TableCell>
      <TableCell />
      <TableCell colSpan={2}>
        <CustomCell>
          <PublicIcon
            style={{ color: theme.palette.grey[500], marginRight: 10 }}
          />
          <div>{productInstance.name_for_resign || productInstance.name}</div>
          <CustomArrowForwardIcon />
          <PublicIcon
            style={{ color: theme.palette.grey[500], marginRight: 10 }}
          />
          <div>{resignProductName}</div>
        </CustomCell>
      </TableCell>
      <TableCell />
      <TableCell>
        {isResignProduct
          ? getTotalPrice(productInstance.evo_services)
          : resignProductPrice}
      </TableCell>
      <TableCell className="u-nowrap">{productInstance.end_date_ymd}</TableCell>
      <TableCell className="u-text-right" style={{ paddingRight: 0 }}>
        {actions}
      </TableCell>
    </TableRow>
  );
}

export default MPFProductChangesRow;
